/* eslint-disable */
/**
 * This file was generated by 'vite-plugin-kit-routes'
 *
 *      >> DO NOT EDIT THIS FILE MANUALLY <<
 */

/**
 * PAGES
 */
const PAGES = {
  "/forgot-password": `/forgot-password`,
  "/google-login-redirect": `/google-login-redirect`,
  "/sign-up": `/sign-up`,
  "/sign-up-advertiser": `/sign-up-advertiser`,
  "/invite": `/invite`,
  "/": `/`,
  "/advertisers/email-message": `/advertisers/email-message`,
  "/advertisers/list": `/advertisers/list`,
  "/advertisers/list/[revenueOriginId]": (params: { revenueOriginId: (string | number) }) => {
    return `/advertisers/list/${params['revenueOriginId']}`
  },
  "/advertisers/list/create": `/advertisers/list/create`,
  "/advertisers/list/create-options": `/advertisers/list/create-options`,
  "/advertisers/open-balance": `/advertisers/open-balance`,
  "/advertisers/settled-balance": `/advertisers/settled-balance`,
  "/affiliate-managers": `/affiliate-managers`,
  "/affiliate-managers/[accountId]": (params: { accountId: (string | number) }) => {
    return `/affiliate-managers/${params['accountId']}`
  },
  "/affiliate-managers/invite": `/affiliate-managers/invite`,
  "/affiliate/detail/[accountId]": (params: { accountId: (string | number) }) => {
    return `/affiliate/detail/${params['accountId']}`
  },
  "/affiliate/email-message": `/affiliate/email-message`,
  "/affiliate/list": `/affiliate/list`,
  "/affiliate/list/[accountId]": (params: { accountId: (string | number) }) => {
    return `/affiliate/list/${params['accountId']}`
  },
  "/affiliate/list/create": `/affiliate/list/create`,
  "/affiliate/list/import": `/affiliate/list/import`,
  "/affiliate/popup-message": `/affiliate/popup-message`,
  "/affiliate/popup-message/[messageId]": (params: { messageId: (string | number) }) => {
    return `/affiliate/popup-message/${params['messageId']}`
  },
  "/affiliate/popup-message/create": `/affiliate/popup-message/create`,
  "/alerts": `/alerts`,
  "/alerts/create": `/alerts/create`,
  "/alerts/edit/[id]": (params: { id: (string | number) }) => {
    return `/alerts/edit/${params['id']}`
  },
  "/billing-details": `/billing-details`,
  "/billing/open-balance": `/billing/open-balance`,
  "/billing/payment-methods": `/billing/payment-methods`,
  "/billing/settled-balance": `/billing/settled-balance`,
  "/billing/settled-balance/[settlementId]": (params: { settlementId: (string | number) }) => {
    return `/billing/settled-balance/${params['settlementId']}`
  },
  "/billing/settled-balance/[settlementId]/export": (params: { settlementId: (string | number) }) => {
    return `/billing/settled-balance/${params['settlementId']}/export`
  },
  "/billing/settled-balance/[settlementId]/invoice/[accountSettlementId]": (params: { settlementId: (string | number), accountSettlementId: (string | number) }) => {
    return `/billing/settled-balance/${params['settlementId']}/invoice/${params['accountSettlementId']}`
  },
  "/coupons/list": `/coupons/list`,
  "/coupons/list/import": `/coupons/list/import`,
  "/coupons/list/new": `/coupons/list/new`,
  "/create-offer/[offerId]/creatives": (params: { offerId: (string | number) }) => {
    return `/create-offer/${params['offerId']}/creatives`
  },
  "/create-offer/[offerId]/general": (params: { offerId: (string | number) }) => {
    return `/create-offer/${params['offerId']}/general`
  },
  "/create-offer/[offerId]/landing-pages": (params: { offerId: (string | number) }) => {
    return `/create-offer/${params['offerId']}/landing-pages`
  },
  "/create-offer/[offerId]/launch": (params: { offerId: (string | number) }) => {
    return `/create-offer/${params['offerId']}/launch`
  },
  "/create-offer/[offerId]/revenue-payouts": (params: { offerId: (string | number) }) => {
    return `/create-offer/${params['offerId']}/revenue-payouts`
  },
  "/dashboard": `/dashboard`,
  "/environment/[...path]": (params: { path: (string | number)[] }) => {
    return `/environment/${params['path']?.join('/')}`
  },
  "/integrations": `/integrations`,
  "/integrations/[trackingMethod]": (params: { trackingMethod: (string | number) }) => {
    return `/integrations/${params['trackingMethod']}`
  },
  "/integrations/builder": `/integrations/builder`,
  "/integrations/from-scratch": `/integrations/from-scratch`,
  "/integrations/help": `/integrations/help`,
  "/logs/activity": `/logs/activity`,
  "/logs/activity/[id]": (params: { id: (string | number) }) => {
    return `/logs/activity/${params['id']}`
  },
  "/logs/conversion": `/logs/conversion`,
  "/logs/conversion/[requestId]": (params: { requestId: (string | number) }) => {
    return `/logs/conversion/${params['requestId']}`
  },
  "/logs/postbacks": `/logs/postbacks`,
  "/logs/postbacks/[postbackId]": (params: { postbackId: (string | number) }) => {
    return `/logs/postbacks/${params['postbackId']}`
  },
  "/marketplace": `/marketplace`,
  "/offers/[offerId]/affiliate-tracking": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/affiliate-tracking`
  },
  "/offers/[offerId]/anura": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/anura`
  },
  "/offers/[offerId]/caps": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/caps`
  },
  "/offers/[offerId]/caps/[capId]": (params: { offerId: (string | number), capId: (string | number) }) => {
    return `/offers/${params['offerId']}/caps/${params['capId']}`
  },
  "/offers/[offerId]/caps/new": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/caps/new`
  },
  "/offers/[offerId]/creatives": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/creatives`
  },
  "/offers/[offerId]/general": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/general`
  },
  "/offers/[offerId]/integrations": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/integrations`
  },
  "/offers/[offerId]/integrations/[trackingMethod]": (params: { offerId: (string | number), trackingMethod: (string | number) }) => {
    return `/offers/${params['offerId']}/integrations/${params['trackingMethod']}`
  },
  "/offers/[offerId]/ip-whitelisting": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/ip-whitelisting`
  },
  "/offers/[offerId]/landing-pages": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/landing-pages`
  },
  "/offers/[offerId]/quality-control": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/quality-control`
  },
  "/offers/[offerId]/redirect-domain": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/redirect-domain`
  },
  "/offers/[offerId]/revenue-payouts": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/revenue-payouts`
  },
  "/offers/[offerId]/smart-links": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/smart-links`
  },
  "/offers/[offerId]/smart-links/[smartLinkId]": (params: { offerId: (string | number), smartLinkId: (string | number) }) => {
    return `/offers/${params['offerId']}/smart-links/${params['smartLinkId']}`
  },
  "/offers/[offerId]/smart-links/create": (params: { offerId: (string | number) }) => {
    return `/offers/${params['offerId']}/smart-links/create`
  },
  "/offers/[offerId]/smart-links/get-link/[smartLinkId]": (params: { offerId: (string | number), smartLinkId: (string | number) }) => {
    return `/offers/${params['offerId']}/smart-links/get-link/${params['smartLinkId']}`
  },
  "/offers/applications": `/offers/applications`,
  "/offers/applications/[applicationId]": (params: { applicationId: (string | number) }) => {
    return `/offers/applications/${params['applicationId']}`
  },
  "/offers/list/[status]": (params: { status: (string | number) }) => {
    return `/offers/list/${params['status']}`
  },
  "/offers/list/[status]/create": (params: { status: (string | number) }) => {
    return `/offers/list/${params['status']}/create`
  },
  "/offers/list/[status]/create/advertiser": (params: { status: (string | number) }) => {
    return `/offers/list/${params['status']}/create/advertiser`
  },
  "/offers/list/[status]/create/complete": (params: { status: (string | number) }) => {
    return `/offers/list/${params['status']}/create/complete`
  },
  "/offers/list/[status]/create/currency": (params: { status: (string | number) }) => {
    return `/offers/list/${params['status']}/create/currency`
  },
  "/offers/list/[status]/create/landing-page": (params: { status: (string | number) }) => {
    return `/offers/list/${params['status']}/create/landing-page`
  },
  "/offers/list/[status]/create/name": (params: { status: (string | number) }) => {
    return `/offers/list/${params['status']}/create/name`
  },
  "/offers/list/[status]/create/non-transactional": (params: { status: (string | number) }) => {
    return `/offers/list/${params['status']}/create/non-transactional`
  },
  "/offers/list/[status]/create/optional-payout": (params: { status: (string | number) }) => {
    return `/offers/list/${params['status']}/create/optional-payout`
  },
  "/offers/list/[status]/create/payout-type": (params: { status: (string | number) }) => {
    return `/offers/list/${params['status']}/create/payout-type`
  },
  "/offers/list/[status]/create/recurring": (params: { status: (string | number) }) => {
    return `/offers/list/${params['status']}/create/recurring`
  },
  "/offers/list/[status]/create/set-payout": (params: { status: (string | number) }) => {
    return `/offers/list/${params['status']}/create/set-payout`
  },
  "/offers/payout-builder": `/offers/payout-builder`,
  "/offers/payout-builder/[adjustmentId]": (params: { adjustmentId: (string | number) }) => {
    return `/offers/payout-builder/${params['adjustmentId']}`
  },
  "/offers/payout-builder/create": `/offers/payout-builder/create`,
  "/offers/smart-links": `/offers/smart-links`,
  "/offers/smart-links/[smartLinkId]": (params: { smartLinkId: (string | number) }) => {
    return `/offers/smart-links/${params['smartLinkId']}`
  },
  "/offers/smart-links/create": `/offers/smart-links/create`,
  "/offers/smart-links/get-link/[smartLinkId]": (params: { smartLinkId: (string | number) }) => {
    return `/offers/smart-links/get-link/${params['smartLinkId']}`
  },
  "/pages/[slug]": (params: { slug: (string | number) }) => {
    return `/pages/${params['slug']}`
  },
  "/referral-program": `/referral-program`,
  "/reports/builder": `/reports/builder`,
  "/reports/click": `/reports/click`,
  "/reports/click/[clickId]": (params: { clickId: (string | number) }) => {
    return `/reports/click/${params['clickId']}`
  },
  "/reports/conversion": `/reports/conversion`,
  "/reports/conversion/[clickId]": (params: { clickId: (string | number) }) => {
    return `/reports/conversion/${params['clickId']}`
  },
  "/reports/conversion/import": `/reports/conversion/import`,
  "/reports/conversion/import/new": `/reports/conversion/import/new`,
  "/reports/conversion/import/update": `/reports/conversion/import/update`,
  "/reports/daily-overview": `/reports/daily-overview`,
  "/reports/mlm-commission": `/reports/mlm-commission`,
  "/reports/mlm-commission/[clickId]": (params: { clickId: (string | number) }) => {
    return `/reports/mlm-commission/${params['clickId']}`
  },
  "/reports/overview": `/reports/overview`,
  "/settings": `/settings`,
  "/settings/[id]": (params: { id: (string | number) }) => {
    return `/settings/${params['id']}`
  },
  "/settings/advertiser-communication": `/settings/advertiser-communication`,
  "/settings/advertiser-data-visibility": `/settings/advertiser-data-visibility`,
  "/settings/advertiser-payment-method": `/settings/advertiser-payment-method`,
  "/settings/advertisers-general": `/settings/advertisers-general`,
  "/settings/affiliate-postbacks": `/settings/affiliate-postbacks`,
  "/settings/affiliate-registration": `/settings/affiliate-registration`,
  "/settings/affiliate-tracking-links": `/settings/affiliate-tracking-links`,
  "/settings/alerts": `/settings/alerts`,
  "/settings/anura": `/settings/anura`,
  "/settings/click-tracking": `/settings/click-tracking`,
  "/settings/company-details": `/settings/company-details`,
  "/settings/conversion-types": `/settings/conversion-types`,
  "/settings/currencies": `/settings/currencies`,
  "/settings/custom-internal-pages": `/settings/custom-internal-pages`,
  "/settings/custom-menu": `/settings/custom-menu`,
  "/settings/dashboard-and-reports": `/settings/dashboard-and-reports`,
  "/settings/data-visibility": `/settings/data-visibility`,
  "/settings/email-customization": `/settings/email-customization`,
  "/settings/email-customization/[emailType]": (params: { emailType: (string | number) }) => {
    return `/settings/email-customization/${params['emailType']}`
  },
  "/settings/fraud-prevention": `/settings/fraud-prevention`,
  "/settings/mlm": `/settings/mlm`,
  "/settings/payment-methods": `/settings/payment-methods`,
  "/settings/payout-automation": `/settings/payout-automation`,
  "/settings/payout-automation/submit-authorization-code": `/settings/payout-automation/submit-authorization-code`,
  "/settings/personal-access-tokens": `/settings/personal-access-tokens`,
  "/settings/quality-control": `/settings/quality-control`,
  "/settings/redirect-domains": `/settings/redirect-domains`,
  "/settings/shopify-integration": `/settings/shopify-integration`,
  "/settings/smart-links": `/settings/smart-links`,
  "/settings/terms": `/settings/terms`,
  "/settings/tiers": `/settings/tiers`,
  "/settings/tiers/[tierId]/automation": (params: { tierId: (string | number) }) => {
    return `/settings/tiers/${params['tierId']}/automation`
  },
  "/settings/tiers/[tierId]/edit": (params: { tierId: (string | number) }) => {
    return `/settings/tiers/${params['tierId']}/edit`
  },
  "/settings/tiers/automations": `/settings/tiers/automations`,
  "/settings/tiers/create": `/settings/tiers/create`,
  "/settings/tracking-api-authorization": `/settings/tracking-api-authorization`,
  "/settings/users": `/settings/users`,
  "/sub-affiliates": `/sub-affiliates`,
  "/track/postbacks-templates": `/track/postbacks-templates`,
  "/track/postbacks-templates/[postbackTemplateId]": (params: { postbackTemplateId: (string | number) }) => {
    return `/track/postbacks-templates/${params['postbackTemplateId']}`
  },
  "/trackdesk-academy": `/trackdesk-academy`,
  "/trackdesk-academy/chapter/[chapterId]": (params: { chapterId: (string | number) }) => {
    return `/trackdesk-academy/chapter/${params['chapterId']}`
  },
  "/trackdesk-academy/section/[sectionId]": (params: { sectionId: (string | number) }) => {
    return `/trackdesk-academy/section/${params['sectionId']}`
  },
  "/tracking-blocking": `/tracking-blocking`,
  "/webhooks": `/webhooks`,
  "/terms-conditions": `/terms-conditions`,
  "/tracking-guide": `/tracking-guide`,
  "/tracking-guide/[trackingMethod]": (params: { trackingMethod: (string | number) }) => {
    return `/tracking-guide/${params['trackingMethod']}`
  }
}

/**
 * SERVERS
 */
const SERVERS = {
  "GET /geoip-locations": `/geoip-locations`,
  "GET /search/intercom": `/search/intercom`,
  "GET /quote/[customQuoteId]": (params: { customQuoteId: (string | number) }) => {
    return `/quote/${params['customQuoteId']}`
  }
}

/**
 * ACTIONS
 */
const ACTIONS = {
  
}

/**
 * LINKS
 */
const LINKS = {
  
}

type ParamValue = string | number | boolean | null | undefined

/**
 * Append search params to a string
 */
export const appendSp = (
  sp?: Record<string, ParamValue | ParamValue[]>,
  prefix: '?' | '&' = '?',
) => {
  if (sp === undefined) return ''

  const params = new URLSearchParams()
  const append = (n: string, v: ParamValue) => {
    if (v !== undefined) {
      params.append(n, String(v))
    }
  }

  let anchor = ''
  for (const [name, val] of Object.entries(sp)) {
    if (name === '__KIT_ROUTES_ANCHOR__' && val !== undefined) {
      anchor = `#${val}`
      continue
    }
    if (Array.isArray(val)) {
      for (const v of val) {
        append(name, v)
      }
    } else {
      append(name, val)
    }
  }

  const formatted = params.toString()
  if (formatted || anchor) {
    return `${prefix}${formatted}${anchor}`.replace('?#', '#')
  }
  return ''
}

/**
 * get the current search params
 * 
 * Could be use like this:
 * ```
 * route("/cities", { page: 2 }, { ...currentSP() })
 * ```
 */ 
export const currentSp = () => {
  const params = new URLSearchParams(window.location.search)
  const record: Record<string, string> = {}
  for (const [key, value] of params.entries()) {
    record[key] = value
  }
  return record
}

/* type helpers for route function */
type NonFunctionKeys<T> = { [K in keyof T]: T[K] extends Function ? never : K }[keyof T]
type FunctionKeys<T> = { [K in keyof T]: T[K] extends Function ? K : never }[keyof T]
type FunctionParams<T> = T extends (...args: infer P) => any ? P : never

const AllObjs = { ...PAGES, ...ACTIONS, ...SERVERS, ...LINKS }
type AllTypes = typeof AllObjs

export type Routes = keyof AllTypes extends `${string}/${infer Route}` ? `/${Route}` : keyof AllTypes
export const routes = [
	...new Set(Object.keys(AllObjs).map((route) => /^\/.*|[^ ]?\/.*$/.exec(route)?.[0] ?? route)),
] as Routes[]

/**
 * To be used like this: 
 * ```ts
 * import { route } from './ROUTES'
 * 
 * route('site_id', { id: 1 })
 * ```
 */
export function route<T extends FunctionKeys<AllTypes>>(key: T, ...params: FunctionParams<AllTypes[T]>): string
export function route<T extends NonFunctionKeys<AllTypes>>(key: T): string
export function route<T extends keyof AllTypes>(key: T, ...params: any[]): string {
  if (AllObjs[key] as any instanceof Function) {
    const element = (AllObjs as any)[key] as (...args: any[]) => string
    return element(...params)
  } else {
    return AllObjs[key] as string
  }
}

/**
* Add this type as a generic of the vite plugin `kitRoutes<KIT_ROUTES>`.
*
* Full example:
* ```ts
* import type { KIT_ROUTES } from '$lib/ROUTES'
* import { kitRoutes } from 'vite-plugin-kit-routes'
*
* kitRoutes<KIT_ROUTES>({
*  PAGES: {
*    // here, key of object will be typed!
*  }
* })
* ```
*/
export type KIT_ROUTES = {
  PAGES: { '/forgot-password': never, '/google-login-redirect': never, '/sign-up': never, '/sign-up-advertiser': never, '/invite': never, '/': never, '/advertisers/email-message': never, '/advertisers/list': never, '/advertisers/list/[revenueOriginId]': 'revenueOriginId', '/advertisers/list/create': never, '/advertisers/list/create-options': never, '/advertisers/open-balance': never, '/advertisers/settled-balance': never, '/affiliate-managers': never, '/affiliate-managers/[accountId]': 'accountId', '/affiliate-managers/invite': never, '/affiliate/detail/[accountId]': 'accountId', '/affiliate/email-message': never, '/affiliate/list': never, '/affiliate/list/[accountId]': 'accountId', '/affiliate/list/create': never, '/affiliate/list/import': never, '/affiliate/popup-message': never, '/affiliate/popup-message/[messageId]': 'messageId', '/affiliate/popup-message/create': never, '/alerts': never, '/alerts/create': never, '/alerts/edit/[id]': 'id', '/billing-details': never, '/billing/open-balance': never, '/billing/payment-methods': never, '/billing/settled-balance': never, '/billing/settled-balance/[settlementId]': 'settlementId', '/billing/settled-balance/[settlementId]/export': 'settlementId', '/billing/settled-balance/[settlementId]/invoice/[accountSettlementId]': 'settlementId' | 'accountSettlementId', '/coupons/list': never, '/coupons/list/import': never, '/coupons/list/new': never, '/create-offer/[offerId]/creatives': 'offerId', '/create-offer/[offerId]/general': 'offerId', '/create-offer/[offerId]/landing-pages': 'offerId', '/create-offer/[offerId]/launch': 'offerId', '/create-offer/[offerId]/revenue-payouts': 'offerId', '/dashboard': never, '/environment/[...path]': 'path', '/integrations': never, '/integrations/[trackingMethod]': 'trackingMethod', '/integrations/builder': never, '/integrations/from-scratch': never, '/integrations/help': never, '/logs/activity': never, '/logs/activity/[id]': 'id', '/logs/conversion': never, '/logs/conversion/[requestId]': 'requestId', '/logs/postbacks': never, '/logs/postbacks/[postbackId]': 'postbackId', '/marketplace': never, '/offers/[offerId]/affiliate-tracking': 'offerId', '/offers/[offerId]/anura': 'offerId', '/offers/[offerId]/caps': 'offerId', '/offers/[offerId]/caps/[capId]': 'offerId' | 'capId', '/offers/[offerId]/caps/new': 'offerId', '/offers/[offerId]/creatives': 'offerId', '/offers/[offerId]/general': 'offerId', '/offers/[offerId]/integrations': 'offerId', '/offers/[offerId]/integrations/[trackingMethod]': 'offerId' | 'trackingMethod', '/offers/[offerId]/ip-whitelisting': 'offerId', '/offers/[offerId]/landing-pages': 'offerId', '/offers/[offerId]/quality-control': 'offerId', '/offers/[offerId]/redirect-domain': 'offerId', '/offers/[offerId]/revenue-payouts': 'offerId', '/offers/[offerId]/smart-links': 'offerId', '/offers/[offerId]/smart-links/[smartLinkId]': 'offerId' | 'smartLinkId', '/offers/[offerId]/smart-links/create': 'offerId', '/offers/[offerId]/smart-links/get-link/[smartLinkId]': 'offerId' | 'smartLinkId', '/offers/applications': never, '/offers/applications/[applicationId]': 'applicationId', '/offers/list/[status]': 'status', '/offers/list/[status]/create': 'status', '/offers/list/[status]/create/advertiser': 'status', '/offers/list/[status]/create/complete': 'status', '/offers/list/[status]/create/currency': 'status', '/offers/list/[status]/create/landing-page': 'status', '/offers/list/[status]/create/name': 'status', '/offers/list/[status]/create/non-transactional': 'status', '/offers/list/[status]/create/optional-payout': 'status', '/offers/list/[status]/create/payout-type': 'status', '/offers/list/[status]/create/recurring': 'status', '/offers/list/[status]/create/set-payout': 'status', '/offers/payout-builder': never, '/offers/payout-builder/[adjustmentId]': 'adjustmentId', '/offers/payout-builder/create': never, '/offers/smart-links': never, '/offers/smart-links/[smartLinkId]': 'smartLinkId', '/offers/smart-links/create': never, '/offers/smart-links/get-link/[smartLinkId]': 'smartLinkId', '/pages/[slug]': 'slug', '/referral-program': never, '/reports/builder': never, '/reports/click': never, '/reports/click/[clickId]': 'clickId', '/reports/conversion': never, '/reports/conversion/[clickId]': 'clickId', '/reports/conversion/import': never, '/reports/conversion/import/new': never, '/reports/conversion/import/update': never, '/reports/daily-overview': never, '/reports/mlm-commission': never, '/reports/mlm-commission/[clickId]': 'clickId', '/reports/overview': never, '/settings': never, '/settings/[id]': 'id', '/settings/advertiser-communication': never, '/settings/advertiser-data-visibility': never, '/settings/advertiser-payment-method': never, '/settings/advertisers-general': never, '/settings/affiliate-postbacks': never, '/settings/affiliate-registration': never, '/settings/affiliate-tracking-links': never, '/settings/alerts': never, '/settings/anura': never, '/settings/click-tracking': never, '/settings/company-details': never, '/settings/conversion-types': never, '/settings/currencies': never, '/settings/custom-internal-pages': never, '/settings/custom-menu': never, '/settings/dashboard-and-reports': never, '/settings/data-visibility': never, '/settings/email-customization': never, '/settings/email-customization/[emailType]': 'emailType', '/settings/fraud-prevention': never, '/settings/mlm': never, '/settings/payment-methods': never, '/settings/payout-automation': never, '/settings/payout-automation/submit-authorization-code': never, '/settings/personal-access-tokens': never, '/settings/quality-control': never, '/settings/redirect-domains': never, '/settings/shopify-integration': never, '/settings/smart-links': never, '/settings/terms': never, '/settings/tiers': never, '/settings/tiers/[tierId]/automation': 'tierId', '/settings/tiers/[tierId]/edit': 'tierId', '/settings/tiers/automations': never, '/settings/tiers/create': never, '/settings/tracking-api-authorization': never, '/settings/users': never, '/sub-affiliates': never, '/track/postbacks-templates': never, '/track/postbacks-templates/[postbackTemplateId]': 'postbackTemplateId', '/trackdesk-academy': never, '/trackdesk-academy/chapter/[chapterId]': 'chapterId', '/trackdesk-academy/section/[sectionId]': 'sectionId', '/tracking-blocking': never, '/webhooks': never, '/terms-conditions': never, '/tracking-guide': never, '/tracking-guide/[trackingMethod]': 'trackingMethod' }
  SERVERS: { 'GET /geoip-locations': never, 'GET /search/intercom': never, 'GET /quote/[customQuoteId]': 'customQuoteId' }
  ACTIONS: Record<string, never>
  LINKS: Record<string, never>
  Params: { 'revenueOriginId': never, 'accountId': never, 'messageId': never, 'id': never, 'settlementId': never, 'accountSettlementId': never, 'offerId': never, 'path': never, 'trackingMethod': never, 'requestId': never, 'postbackId': never, 'capId': never, 'smartLinkId': never, 'applicationId': never, 'status': never, 'adjustmentId': never, 'slug': never, 'clickId': never, 'emailType': never, 'tierId': never, 'postbackTemplateId': never, 'chapterId': never, 'sectionId': never, 'customQuoteId': never }
}
